import React from 'react';
import './MaLuxPensee.css';

const MaLuxPensee = () => {
    return (
        <div className="aboutus-container">
            <h1 className="aboutus-title">MA · LUX · PENSÉE</h1>

            <div className="aboutus-flex">
                <div className="aboutus-popup-area">
                    <div className="maluxpensee-content">
                        <p className="intro-text">
                            <strong>H'ART ÉLÉGANCE</strong>
                        </p>
                        
                        <p className="tagline">Certains espaces ne s'expliquent pas. Ils s'habitent.</p>

                        <p>
                            Vous entrez dans <strong>MA · LUX · PENSÉE</strong>.
                        </p>

                        <p>
                            Ce n'est pas une rubrique. Ce n'est pas un magazine. C'est un espace de réflexion vivante — sur le corps, sur l'être, sur l'art d'habiter sa propre vie avec justesse et profondeur.
                        </p>

                        <p>
                            Ici, les mots prennent leur temps. Les idées ne sont pas résumées — elles sont traversées. Chaque texte est une invitation à reconnaître ce que vous portez déjà — ce que vous savez, sans l'avoir encore nommé.
                        </p>

                        <p>
                            Ce qui se passe ici appartient à celles qui osent s'arrêter. Qui choisissent la profondeur quand tout le monde court. Qui savent que l'élégance véritable ne s'acquiert pas — elle se révèle.
                        </p>

                        <div className="separator">· · ·</div>

                        <h3>Trois mots. Une philosophie.</h3>

                        <div className="philosophy-section">
                            <h4>MA — japonais ·</h4>
                            <p>
                                L'espace entre les choses. Le silence qui précède et qui permet. Ce vide habité qui donne sens à tout le reste — et sans lequel rien ne peut vraiment advenir.
                            </p>
                        </div>

                        <div className="philosophy-section">
                            <h4>LUX — latin · lux</h4>
                            <p>
                                La lumière. Non pas celle qui vient de l'extérieur, mais celle qui émerge lorsque l'être se réaccorde à lui-même. La clarté qui révèle ce qui était toujours là.
                            </p>
                        </div>

                        <div className="philosophy-section">
                            <h4>PENSÉE — français · pensée</h4>
                            <p>
                                La réflexion incarnée. Pas l'accumulation de savoirs — la pensée qui traverse le corps autant que l'esprit. Celle qui laisse une empreinte.
                            </p>
                        </div>

                        <div className="separator">· · ·</div>

                        <p>
                            Dans cet espace, vous trouverez des textes sur la morphologie émotionnelle — comment le corps porte et exprime nos résonances les plus profondes. Sur l'architecture intérieure — ce que nos histoires ont sculpté dans notre façon d'être au monde. Sur l'élégance — non comme esthétique, mais comme philosophie de vie.
                        </p>

                        <p>
                            Chaque texte est signé. Chaque texte est daté. Chaque texte est une pièce unique.
                        </p>

                        <p>
                            Comme tout ce qui naît ici.
                        </p>

                        <div className="separator">· · ·</div>

                        <p className="closing-meditation">
                            Le silence d'abord. Puis la lumière. Puis la pensée qui émerge — et qui change tout.
                        </p>

                        <h3 className="closing-title">MA · LUX · PENSÉE</h3>

                        <p className="closing-text">
                            La rareté. L'exceptionnel. L'unique.
                        </p>

                        <p className="closing-text">
                            Créé pour vous.
                        </p>

                        <p className="signature">
                            <strong>HASNA</strong><br />
                            Analyste de la Morphologie Émotionnelle<br />
                            H'ART ÉLÉGANCE<br />
                            Maison de Haute Couture de l'Être<br />
                            Mai 2026
                        </p>

                        <div className="separator">· · ·</div>

                        <p className="closing-meditation" style={{marginTop: '2rem', fontSize: '1rem'}}>
                            Si cette pensée résonne avec votre présence, vous pouvez demander un Entretien Stratégique Confidentiel.
                        </p>
                        
                        <div style={{textAlign: 'center', marginTop: '2rem'}}>
                            <a href="#/contact" className="cta-button" style={{fontSize: '0.85rem'}}>Entrer en relation avec la Maison</a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="aboutus-bg-bling">
                <div className="aboutus-bling bling1"></div>
                <div className="aboutus-bling bling2"></div>
                <div className="aboutus-bling bling3"></div>
                <div className="aboutus-bling bling4"></div>
            </div>
        </div>
    );
};

export default MaLuxPensee;
